import React from "react";
import { useFCreditCard } from "./hooks/useFCreditCard";
import styles from "./style/FCreditCard.module.scss";
/* This example requires Tailwind CSS v2.0+ */
import { ChevronRightIcon } from "@heroicons/react/solid";
import VectorIcons from "../VectorIcons/VectorIcons";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const FCreditCard = ({
  lastDigits,
  expMonth,
  expYear,
  name,
  type = "other",
  checked = false,
}) => {
  return (
    <>
      <div className="border-2 border-[white]">
        <div className={`absolute w-full h-full ${checked ? " " : "hidden"}`}>
          <div className="bg-[#52c41a] rounded-full grid place-items-center w-[30px] xxs:w-[35px] smm:w-[40px] h-[30px] xxs:h-[35px] smm:h-[40px] ml-[180px] xxs:ml-[240px] smm:ml-[280px]">
            <VectorIcons
              name="checkmark-circle-outline"
              cssClasses="text-[15px]"
            />
          </div>
        </div>
        <div
          className="mt-5 flex-shrink-0 border-0 pl-[30px] pr-[10px] rounded-[20px] text-white w-[240px]   xxs:w-[290px] smm:w-[350px] h-[160px] xxs:h-[200px] smm:h-[220px]"
          style={{
            backgroundImage: `linear-gradient(to right,${
              type === "VISA"
                ? "#41295a,#2F0743"
                : type === "MASTERCARD"
                ? "#23074d,#cc5333"
                : type === "AMERICAN_EXPRESS"
                ? "#000428,#004e92"
                : "#232526,#414345"
            } )`,
          }}
        >
          <div className="w-full h-full grid grid-rows-4">
            <div className="border-0 row-span-1 grid place-items-end">
              <img
                className="w-[35px] h-[35px] mr-5"
                src={
                  type === "VISA"
                    ? require("../../components/assets/images/visa.png")
                    : type === "MASTERCARD"
                    ? require("../../components/assets/images/mastercard.png")
                    : type === "AMERICAN_EXPRESS"
                    ? require("../../components/assets/images/american-express.png")
                    : require("../../components/assets/images/other.png")
                }
              />
            </div>
            <div className="border-0 row-span-1 grid items-center">
              <img
                src={require("../../components/assets/images/chip.png")}
                className="h-[25px] xxs:h-[30px] smm:h-[35px]"
                alt=""
              />
            </div>
            <div className="border-0 row-span-1 font-bold text-[5vw] xxs:text-[19px]">
              **** **** **** {lastDigits}
            </div>
            <div className="border-0 row-span-1 grid grid-cols-2">
              <div className="border-20col-span-1 font-semibold text-[3.3vw] xxs:text-[14px]">
                {name}
              </div>
              <div className="border-0 col-span-1 font-semibold text-[3.3vw] xxs:text-[14px]">
                Exp Date: {expMonth}/{expYear}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FCreditCard;
